import styles from './page.module.css';

export default function StepList({ member }: { member: string }) {
	const url = window.location.href;
	const parts = url.split('/');
	const lastPart = parts[parts.length - 1];
	return (
		<ol>
			<li className={`${styles.list} ${lastPart.startsWith('expense-detail') ? styles['bold-style'] : ''}`}>
				Select {member} to settle with
			</li>
			<li className={`${styles.list} ${lastPart === 'payee' ? styles['bold-style'] : ''}`}>
				Add settlement details
			</li>
		</ol>
	);
}
